import type { BookingData } from "@/types";

export default async function submitBookingForm(data: BookingData) {
  try {
    const req = await fetch("/api/bookings", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!req.ok) throw new Error("");
    return {
      success: true,
    };
  } catch (error) {
    console.error("Form submission error details:", error);
    return {
      success: false,
      messages: {
        en: "An error occurred, please try again later.",
        de: "Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut.",
      },
    };
  }
}
